import { Document, Page, Image, StyleSheet, View, Text, Font } from '@react-pdf/renderer'
var moment = require('moment');

Font.register({
    family: 'Arial',
    fonts: [
        {
            src: `./fonts/Arial-Regular.ttf`
        },
        {
            src: `./fonts/Arial-Bold.ttf`,
            fontWeight: 'bold'
        },
        {
            src: `./fonts/Arial-Italic.ttf`,
            fontWeight: 'normal',
            fontStyle: 'italic'
        },
        {
            src: `./fonts/Arial-BoldItalic.ttf`,
            fontWeight: 'bold',
            fontStyle: 'italic'
        }
    ]
})
Font.registerHyphenationCallback((word) => {
    return [word];
});

const styles = StyleSheet.create({
    page: { fontFamily: 'Arial', backgroundColor: '#fff' },
    frontPage: { flex: 1, flexDirection: "column", justifyContent: "space-around", alignItems: "center", textAlign: 'center', margin: 30, marginBottom: 0 },
    reportTitle: { fontSize: 20, color: '#000', marginTop: '30px', fontWeight: 600, },
    tableOfContentsHeading: { fontSize: 14, color: '#000' },
    logo: { width: '260px' },
    subjectName: { fontSize: '16px', fontWeight: 600, color: '#000', marginBottom: 5, },
    orgName: { fontSize: '12px', color: '#000' },
    dynamicClientLogo:{ width: '200px', maxHeight: '200px', overflow: 'hidden'},
    layout: { margin: "30px", },
    tableOfContents: { height: "600px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", },
    tableOfContentsList: { width: "80%", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "15px", borderBottom: "1px solid #eee", },
    mb2: { marginBottom: "20px" },
    mt3: { marginTop: "30px" },
    mt2: { marginTop: "20px" },
    pt1: { paddingTop: "10px" },
    pt2: { paddingTop: "20px" },
    pt3: { paddingTop: "30px" },
    mb1: { marginBottom: "10px" },
    introduction: { padding: "2.5% 5% 2% 5%", position: "relative", flex: 1 },
    introduction2: { padding: "3% 5%", position: "relative" },
    introductionHeading: { color: "#000", marginBottom: "6px", fontSize: 18 },
    introductionHeadingBorder: { width: "100%", height: "2px", backgroundColor: "#45A7C4", marginBottom: "20px", },
    // paraText: { marginTop: 0, marginBottom: "15px", fontSize: "9px", color: "#000", fontWeight: 500, lineHeight: "1.5" },
    paraText: { marginTop: 0, marginBottom: "15px", fontSize: 12, color: "#000", fontWeight: 500, lineHeight: "1.5", wordBreak: "break-word", whiteSpace: "normal", overflowWrap:"break-word",WebkitHyphens: "none", MozHyphens: "none", msHyphens: "none", hyphens: "none"  },
    paraHeading: { marginTop: "20px", marginBottom: "10px", fontSize: 14, fontWeight: 700, },
    ratersTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "5px 0px", borderBottom: "1px solid #eee", },
    ratersTableContent: { fontSize: "12px", color: "#000", fontWeight: 400, },
    strengthListHeader: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#3fa8c6", padding: "10px 0px", borderRadius: "2px", },
    strengthList: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #eee", padding: "10px 0px", },
    strengthListHeading: { width: "80%", margin: 0, padding: 0, fontSize: "10px", fontWeight: "500", lineHeight: "1.5", color: "#000", display: "flex", justifyContent: "center", alignItems: "center", },
    strengthListScore: { width: "25px", height: "25px", paddingTop: "7px", backgroundColor: "#3fa8c6", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", color: "#fff", fontSize: "9px", fontWeight: "bold", borderRadius: "50%" },
    SlSelf: { fontSize: "10px", color: "#fff", marginRight: "18px", },
    questionSection: { padding: "5px", },
    questionSectionQue: { marginTop: "10px", marginBottom: "8px", fontSize: "13px", color: "#000", lineHeight: "1.5", fontWeight: 700, },
    questionSectionAns: { paddingBottom: "10px", fontSize: "11px", color: "#000", lineHeight: "1.5", },
    answerSection: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid #f2f2f2", },
    answerSectionGroupName: { width: "20%", fontSize: "11px", color: "#000", lineHeight: "1.5" },
    answerSectionGroupAnswer: { width: "80%" },
    opinionScaleView: { display: "flex", flexDirection: "row", justifyContent: "flex-start" },
    ssimg: { width: '300px', textAlign: 'left' },
    spantext: { textAlign: 'center', color: '#000', padding: '20px', fontSize: '11px' },
    ratingthead: { fontSize: 10, fontWeight: 600, paddingLeft: 5, paddingRight: 5, color: '#000' },
    ratingtbody: { fontSize: 10, padding: 0, paddingLeft: 5, paddingRight: 5, color: '#000', },
    w480: { width: 480, textAlign: 'center'  },
    w33: { width: '33.33%' },
    ratingtbodygap: { color: 'rgb(255, 62, 29)', fontWeight: 800 },
    green: { color: 'rgb(40, 167, 69)', fontWeight: 800 },
    tableflex1: { flex: 1 },
    tableflex2: { flex: 2 },
    tableflex3: { flex: 3 },
    tablefw: { fontWeight: 600, color: '#000', fontSize: "12px" },
    questionText: { fontWeight: 500, color: '#000', fontSize: 12, marginTop: 'auto', marginBottom: 'auto', paddingRight: 10, wordBreak: "normal", whiteSpace: "pre-wrap",WebkitHyphens: "none", MozHyphens: "none", msHyphens: "none", hyphens: "none"  },
    competencyComments: { padding: "10% 0 10% 0" },
    // competencyComments2: { padding: "3.5% 0 10% 0" },
    competencyComments2: { padding: "3% 0%" },
    pageSubHeading: { color: "#000", fontSize: "14px", marginBottom: "15px" },
    rjPageSubHeading: { color: "#000", fontSize: 14, fontWeight: 800, marginBottom: "0px" },
    // competencyCommentsQuestion: { backgroundColor: "#f1f2f3", color: "#777", fontSize: "11px", marginBottom: "15px", padding: "10px", },
    competencyCommentsQuestion: { backgroundColor: "#f1f2f3", color: "#000", fontSize: 12, marginBottom: "15px", padding: "10px", },
    // competencyCommentsAnswer: { color: "#777", fontSize: "10px", lineHeight: '2px', },
    competencyCommentsAnswer: { color: "#000", fontSize: 10, lineHeight: '1.5px', },
    textAlignCenter: { textAlign: "center", display: "flex", alignItems: "center" },
    textAlignRight: { textAlign: "right", display: "flex", alignItems: "right" },
    pageCount: { position: "absolute", bottom: 20, left: 0, right: 0, textAlign: "center", },
    pageCountText: {  color: "#000", fontSize: "11px", fontWeight: 500 },
    ratingPoint: { fontWeight: 600, color: '#000', paddingTop: '5px' },
    success: { backgroundColor: 'green', color: '#fff' },
    danger: { backgroundColor: 'red', color: '#fff' },
    w7: { width: '2%' },
    w10: { height: '35%' },
    w52: { width: '58%', },
    overallthead: { fontSize: 7, fontWeight: 600, color: '#000', height: '15px', paddingTop: '8px', display: "flex", alignItems: "center", justifyContent: "center", },
    overallbody: { fontSize: 7, color: '#000', padding: '4px 2px', },
    overallTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", borderBottom: "1px solid #eee" },
    executiveTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", lineHeight: '2.5px', },
    competencyScoresContentHeading: { display: "flex", flexDirection: "row", justifyContent: "flex-start" },
    competencyScoresContent: { display: "flex", flexDirection: "row", justifyContent: "flex-around" },
    competencyScoresContentMb1: { marginBottom: "5px" },
    competencyScoresHeading: {
        color: "#3fa8c6",
        fontSize: 12,
        fontWeight: 600
    },
    competencyScoresBlank: {
        width: "20%"
    },
    competencyScoresChart: {
        width: "70%"
    },
    competencyScoresChartTextRight: {
        textAlign: "right"
    },
    competencyScoresChartImage: {
        width: "100%",
    },
    competencyScoresAvg: {
        // width: "10%"
        width: "12%"
    },
    // competencyBreakdownAvgScore: {
    //     marginTop: "5px",
    //     marginBottom: 0,
    //     fontSize: "8px",
    //     fontWeight: 800,
    // },
    

   
    competencyBreakdownAvgScore2: {
        marginTop: "6px",
        marginBottom: '-1px',
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore3: {
        marginTop: "5px",
        marginBottom: '2px',
        fontSize: "7px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore4: {
        marginTop: "7px",
        marginBottom: '-3px',
        fontSize: "7.8px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore5: {
        marginTop: "5px",
        marginBottom: '-2.5px',
        fontSize: "7px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore6: {
        marginTop: "5px",
        marginBottom: '-1.3px',
        fontSize: "7px",
        fontWeight: 800,
    },
    competencyBreakdownAvgScore7: {
        marginTop: "6.5px",
        marginBottom: '-2px',
        fontSize: "7px",
        fontWeight: 800,
    },  
    competencyScoresAvgScore: {
        marginTop: "2px",
        marginBottom: 0,
        fontSize: "7px"
    },
    competencyoverviewAvgScore2: {
        marginTop: "10px",
        marginBottom: 0,
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore3: {
        marginTop: "10px",
        marginBottom: '0px',
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore4: {
        marginTop: "8px",
        marginBottom: '-2px',
        fontSize: "9px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore5: {
        marginTop: "8px",
        marginBottom: '-3px',
        fontSize: "8.5px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore6: {
        marginTop: "10px",
        marginBottom: '-3.5px',
        fontSize: "8px",
        fontWeight: 800,
    },
    competencyoverviewAvgScore7: {
        marginTop: "10px",
        marginBottom: '-2px',
        fontSize: "8px",
        fontWeight: 800,
    },
    rotate: {
        transform: 'rotate(270deg)',
        transformOrigin: 'bottom left',
        textAlign: 'left',
        marginBottom: '20px',
        marginTop: '20px',
    },
    w2: {
        width: '2%'
    },
    w98: {
        width: '98%'
    },
    w3: {
        width: '3%'
    },
    circleLegend: {
        width: "20px",
        height: "5px",
        borderRadius: "10px",
        marginRight: '5px',
    },
    w94: {
        width: '94%'
    },
    ratingText: { fontSize: 12, paddingLeft: 2, paddingRight: 2, color: '#000', },
    blueColor: { color: '#45A7C4' },
    textColor: { color: '#000' },
    // grayColor: { color: '#8E8E8E' },
    grayColor: { color: '#000' },
    overallFlex: { display: 'inline', flexDirection: 'row', justifyContent: "flex-start" },
    lastTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: 'center', marginTop: '5px', alignItems: 'flex-start', padding: "0px 0px", gap: '1px'},
    // renderRatingScale: {
    //     width: "100%",
    //     display: "flex",
    //     flexDirection: "row",
    //     flexWrap: "wrap",
    //     justifyContent: "center",
    //     marginTop: "-5px",
    //     alignItems: "flex-start",
    //     padding: "0px 0px 4px",
    //     gap: "3px",
    // },
    renderRatingScale: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    lastBulletWidth: { width: '5%', fontSize: 9 },
    lastParaWidth: { width: '98%' },
    w16: { width: '16.67%' },
    w25: { width: '25%' },
    w13: { width: '10%' },
    w11: { width: '11%' },
    w18: { width: '22%' },
    w8: { width: '8%' },
    w1: { width: '1%' },
    fs9: { fontSize: 9 },
    overalltext: { fontSize: 8, padding: '4px 2px', },
    nowrap: { whiteSpace: 'pre-wrap' },
    legendTable: { width: "100%", display: "flex", flexDirection: "row", alignItems: 'center' },
    legendContainer: { width: "100%", display: "flex", flexDirection: "row", alignItems: 'flex-start', flexWrap: 'wrap' },
    mr5px: { marginRight: '3px' },
    fs7: { fontSize: 7 },
    ReviewTable: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "10px" },
    textCenter: { textAlign: 'center', },
    fw600: { fontWeight: 600 },
    mb3px: { marginBottom: '3px' },
    openEndedComment: { width: "100%", display: "flex", flexDirection: "row", justifyContent: "flex-start", marginBottom: "10px" },
    fs10: { fontSize: 10 },
    fs11: { fontSize: 11 },
    fs12: { fontSize: 12 },
    alignItems: {alignItems: 'center'},
    pointBox: {
        flexDirection: "row",
        width: "100%",
        alignItems: "flex-start",
        marginBottom: 15,
    },
    pointNumber: { width: 10 },
});

const ReportDownloadView = ({ report, onPageRender, pageNumbers }) => {
    var compIndex = 0;

    const getCategoryInitials = (category) => {
        if (!category) return '';

        const words = category.trim().split(' ');

        // Single word → first letter
        if (words.length === 1) {
            return words[0][0].toUpperCase();
        }

        // Multi-word → take first letter of first 2 words
        const first = words[0][0].toUpperCase();
        const second = words[1][0].toUpperCase();

        return first + second;
    };

    const getRatingOptions = () => {
        const defaultOptions = [
            "Not Observed",
            "Never/Rarely",
            "Occasionally",
            "Sometimes",
            "Often",
            "Always/Almost Always"
        ];

        if (!report) return defaultOptions;

        const scalePoint = Number(report.scalePoint);
        const measurementType = report.measurementType;

        const optionsMap = {
            5: {
                Frequency:["Not Observed","Never","Rarely","Sometimes","Often","Always"],
                Quality: ["Not Observed","Poor","Fair","Good","Very Good","Excellent"],
                Agreement: ["Not Observed","Strongly Disagree","Disagree","Neutral","Agree","Strongly Agree"],
                Proficiency: ["Not Observed","Novice","Developing","Competent","Proficient","Expert"],
                Demonstration: ["Not Observed","Not Demonstrated","Partially Demonstrated","Adequately Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
            },
            7: {
                Frequency: ["Not Observed","Never","Rarely","Occasionally","Sometimes","Frequently","Often","Always"],
                Quality: ["Not Observed","Poor","Weak","Fair","Good","Very Good","Strong","Excellent"],
                Agreement:["Not Observed","Strongly Disagree","Disagree","Somewhat Disagree","Neutral","Somewhat Agree","Agree","Strongly Agree"],
                Proficiency: ["Not Observed","Novice","Developing","Competent","Proficient","Advanced","Expert","Master"],
                Demonstration: ["Not Observed","Not Demonstrated","Slightly Demonstrated","Partially Demonstrated","Adequately Demonstrated","Substantially Demonstrated","Fully Demonstrated","Exceptionally Demonstrated"]
            }
        };

        return optionsMap[scalePoint]?.[measurementType] || defaultOptions;
    };

    const getScaleRange = () => {
        const scalePoint = Number(report?.scalePoint);
        return (!scalePoint || isNaN(scalePoint)) ? "0-5" : `0-${scalePoint}`;
    };

    const ratingOptions = getRatingOptions();

    const shuffleArray = (array) => {
        const shuffled = [...array];

        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));

            [shuffled[i], shuffled[j]] = [
                shuffled[j],
                shuffled[i]
            ];
        }

        return shuffled;
    };

    const renderRatingScale = (marginTop = '7px') => {
        return (
            <View style={[styles.renderRatingScale, { marginTop }]}>
                {ratingOptions.map((label, index) => {
                    let widthStyle = styles.w16;

                    // if (ratingOptions.length === 6) {
                    //     if (index === 4) widthStyle = styles.w13;
                    //     if (index === 5) widthStyle = styles.w18;
                    // }

                    return (
                        <View key={index} style={[{ marginRight: 10, flexShrink: 0 }]}>
                            <Text>
                                <Text style={[styles.overalltext, styles.fs8, styles.blueColor]}>
                                    {index}
                                </Text>
                                <Text style={[styles.overalltext, styles.fs8, styles.blueColor]}>
                                    {" - "}
                                </Text>
                                <Text style={[styles.overalltext, styles.fs8, styles.blueColor]}>
                                    {label}
                                </Text>
                            </Text>
                        </View>
                    );
                })}
            </View>
        );
    };
    // console.log("renderRatingScale",renderRatingScale);
    
    

    return (
        <Document>
            <Page wrap style={styles.page}>
                <View style={styles.frontPage}>
                    {/* <Text style={styles.reportTitle}>{report?.reportTitle}</Text> */}
                    <View style={styles.textAlignCenter}>
                        <Image style={styles.logo} src={process.env.REACT_APP_BASE_URL + "assets/img/first-feedback-logo.png"} />
                        <Text style={[styles.subjectName, {marginTop: 50}]}>{report?.subjectName}{report.subjectTitle !== null && report.subjectTitle != '' ? ', '+report.subjectTitle : ''}</Text>
                        {/* <Text style={styles.orgName}>{report?.organizationName}</Text> */}
                        <Text style={styles.orgName}>{moment(new Date()).format('MMMM  DD, YYYY')}</Text>
                    </View>
                    <Image style={styles.ssimg} src={process.env.REACT_APP_BASE_URL + "assets/img/5.png"} />
                    <View style={styles.dynamicClientLogo}>
                        {report?.logo1 ? (
                            <Image style={{width: '100%', height: 'auto', objectFit: 'contain'}} 
                                 
                                src={report.logo1}
                            />
                        ) : (
                            /* Spacer if no logo exists to keep layout consistent */
                            <View />
                        )}
                    </View>
                    <Text style={styles.spantext}>Copyright (c) ClearPoint Leadership Strategies.  All rights reserved.</Text>
                </View>
            </Page>
            <Page wrap style={styles.page}>
                
                <View style={styles.tableOfContents}>
                    <Text style={[styles.reportTitle, styles.mb2]}>Table of Contents</Text>
                    {
                        report.reportContents !== null ? report.reportContents.map((reportContent, index) => {
                            const pageInfo = pageNumbers?.current[reportContent.name];
                            const pageRange = pageInfo
                            ? pageInfo.start === pageInfo.end
                                ? `${pageInfo.start}`
                                : `${pageInfo.start} - ${pageInfo.end}`
                            : 'Loading...';
                            return (
                                <View style={[styles.tableOfContentsList, index === 0 ? styles.mt2 : '']}>
                                    <Text style={styles.tableOfContentsHeading}>
                                        {reportContent.name === "Hidden Strengths/Opportunities" ? "Hidden Strengths/Blind Spots" : reportContent.name}
                                    </Text>
                                    <Text style={styles.tableOfContentsHeading}>{pageRange}</Text>
                                    {/* <Text style={styles.tableOfContentsHeading}>{reportContent.pageNo}</Text> */}
                                </View>
                            )
                        }) : <></>
                    }
                    
                </View>
            </Page>
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Introduction") ? 
                <Page wrap style={styles.page}>                    
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Introduction") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Introduction</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Welcome to your ClearPoint360 feedback report!</Text>
                        <Text style={styles.paraText}>This detailed report is crafted to give you a well-rounded view of your professional strengths, areas where you can improve, and the overall impact you have on your team and colleagues across the organization. By carefully analyzing the insights provided, you'll be able to pinpoint key areas to prioritize for your ongoing professional development and career advancement. This report serves as a valuable tool to guide your growth, helping enhance your understanding of your leadership approach and potential impact.</Text>
                        <Text style={[styles.paraHeading, styles.blueColor]}>Respondent Statistics</Text>
                        <Text style={styles.paraText}>This section shows a summary of the # of Raters who were invited to provide input and # of Raters who responded in each Rater Group. Feedback is anonymous.</Text>
                        <View style={styles.ratersTable}>
                            <Text style={[styles.w33, styles.tablefw]}>Rater Group</Text>
                            <Text style={[styles.w33, styles.tablefw, styles.textAlignCenter]}>Completed/Invited</Text>
                            <Text style={[styles.w33, styles.tablefw, styles.textAlignRight]}>% Complete</Text>
                        </View>
                        {
                            report?.raters && Object.keys(report.raters).map((value, index) => {
                                return (
                                    <View key={"raterGroup_" + index} style={styles.ratersTable}>
                                        <Text style={[styles.ratersTableContent, styles.w33]}>{value}</Text>
                                        <Text style={[styles.ratersTableContent, styles.w33, styles.textAlignCenter]}>{report.raters[value]['responded']}/{report.raters[value]['total']}</Text>

                                        <Text style={[styles.ratersTableContent, styles.w33, styles.textAlignRight]}>{Math.round(parseFloat(report.raters[value]['responded'] / report.raters[value]['total']) * 100)}%</Text>
                                    </View>
                                )
                            })
                        }
                        <Text style={[styles.paraHeading, styles.blueColor, styles.pt3]}>Rating Scale and Points</Text>
                        {/* <Text style={styles.paraText}>Respondents are asked to answer questions in this instrument on a 0-5 point scale, as shown below.</Text> */}
                        <Text style={styles.paraText}>
                            Respondents are asked to answer questions in this instrument on a {getScaleRange()} point scale, as shown below.
                        </Text>
                        {getRatingOptions().map((label, index) => (
                            <View style={styles.executiveTable} key={`${label}-${index}`}>
                                <Text style={[styles.ratingText, styles.w3, styles.grayColor]}>
                                    {index}
                                </Text>
                                <Text style={[styles.ratingText, styles.w3, styles.grayColor]}>
                                    {" - "}
                                </Text>
                                <Text style={[styles.ratingText, styles.w94, styles.grayColor]}>
                                    {label}
                                </Text>
                            </View>
                        ))}
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Executive Summary") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Executive Summary") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Executive Summary</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>The ClearPoint360 Report highlights your strengths and opportunities for growth. It categorizes each into areas you're aware of (Confirmed) and areas you're not (Hidden/Blind Spots). This structure makes it easy to pinpoint where to focus your development and recognize where you already excel.</Text>
                        <View style={{marginLeft:"auto",marginRight:"auto"}}><Image style={styles.w480} src={process.env.REACT_APP_BASE_URL + "assets/img/6.png"} /></View>
                        {/* <Text render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )} fixed /> */}

                        {(report?.confirmedStrengths)?<Text style={[styles.paraHeading, styles.blueColor, styles.pt1]}>Your Confirmed Strengths</Text>:""}
                        
                        {
                            report?.confirmedStrengths && report.confirmedStrengths.map((confirmedStrength, csIndex) => {
                                return (
                                    csIndex < 3 ?
                                        <View style={styles.ReviewTable}>
                                            <Text style={[styles.ratingText, styles.w2]}>{`${csIndex + 1}. `}</Text>
                                            <Text style={[styles.ratingText, styles.w98, {lineHeight: "1.2px"}]}>
                                                <Text style={{ fontWeight: 700 }}>
                                                    {confirmedStrength?.competency} -{" "}
                                                </Text>
                                                {/* {confirmedStrength?.question} */}
                                                {confirmedStrength?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}
                                            </Text>
                                        </View>
                                        : <></>
                                )
                            })
                        }

                        {(report?.confirmedOpportunities)?<Text style={[styles.paraHeading, styles.blueColor]}>Your Confirmed Opportunities</Text>:""}
                        {
                            report?.confirmedOpportunities && report.confirmedOpportunities.map((confirmedOpportunity, coIndex) => {
                                return (
                                    coIndex < 3 ?
                                        <View style={styles.ReviewTable}>
                                            <Text style={[styles.ratingText, styles.w2]}>{`${coIndex + 1}. `}</Text>
                                            <Text style={[styles.ratingText, styles.w98, , {lineHeight: "1.2px"}]}>
                                                <Text style={{ fontWeight: 700 }}>
                                                    {confirmedOpportunity?.competency} -{" "}
                                                </Text>
                                                {confirmedOpportunity?.question}
                                                {/* {confirmedOpportunity?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)} */}
                                            </Text>
                                        </View>
                                        : <></>
                                )
                            })
                        }
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Performance Summary") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Performance Summary") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Performance Summary</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={[styles.paraText, { wordBreak: "keep-all" }]}>On this page, the Performance Map summarizes visually the 360° data gathered across the competencies measured. Each spoke represents a specific competency.  Data points along the spokes reflecting your average rating for the competency measured. Each color on the chart corresponds to your Rater Groups such as your Self, Peers, Direct Reports, Manager, etc. A Rater Group and Color legend is shown directly above the diagram for the Rater Groups included in your 360°.</Text>
                        {/* <View>
                            <Image src={`data:image/png;base64,'${report.overviewChartImage}'`} style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                        </View> */}
                        <View style={{ alignItems: 'center', marginVertical: 10 }}>
                            <Image
                                src={`data:image/png;base64,${report.overviewChartImage}`}
                                style={{
                                width: 500,
                                height: 500
                                }}
                            />
                        </View>
                        <Text style={styles.paraText}>By comparing the shapes formed by these colored areas, you can see how your performance is perceived by each group. A larger, more expansive shape indicates stronger performance within that Rater Group or Competency. A smaller, more compact shape suggests opportunities for growth within that Rater Group or Competency. The Performance Map helps you easily identify both your strengths and opportunities for development across Competencies and Rater Groups.</Text>
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Competency Overview") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Competency Overview") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Competency Overview</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>The Competency Overview shows the Competencies and their average scores by Rater Group.</Text>
                        {
                            report?.competencyOverview && report?.competencyOverview.map((overview, index) => {
                                const breakPoint = (Object.keys(report.raters).length + 1) > 5 ? (index + 1 > 5 ? (index + 1 > 9 ? 13 : 9) : 5) : 6;
                                const isPageBreak = (index + 1) % breakPoint === 0;
                                return (
                                    <>
                                    <View 
                                        wrap={false} 
                                        key={"competencyOverview_" + index} 
                                        break={(index + 1) % ((Object.keys(report.raters).length + 1) > 5 ? index + 1 > 5 ? index + 1 > 9 ? 13 : 9 : 5 : 6) === 0 ? true : false} 
                                        style={(index + 1) % ((Object.keys(report.raters).length + 1) > 5 ? index + 1 > 5 ? index + 1 > 9 ? 13 : 9 : 5 : 6) === 0 ? [] : []}
                                    >
                                        {(index + 1) % ((Object.keys(report.raters).length + 1) > 5 ? index + 1 > 5 ? index + 1 > 9 ? 13 : 9 : 5 : 6) === 0 ? <>
                                            <View style={{paddingTop: "2.5%"}}>
                                                <Text style={styles.introductionHeading}>
                                                    Competency Overview, Cont'd
                                                </Text>
                                                <Text style={styles.introductionHeadingBorder}></Text>
                                            </View>
                                        </> : <></>}
                                        <View style={[styles.competencyScoresContentHeading, styles.pt2,]}>
                                            <Text style={[styles.competencyScoresChart, styles.competencyScoresHeading]}>{overview.name}</Text>
                                            <View style={styles.competencyScoresBlank}></View>
                                            <View style={[styles.competencyScoresAvg, { width: "12%" }]}>
                                                <Text style={[styles.blueColor, styles.fs10, { fontWeight: 800, }]} className='competency-scores-avg competency-scores-heading'>Average</Text>
                                            </View>
                                            {/* <Text style={[styles.competencyScoresAvg, styles.competencyScoresHeading]} className='competency-scores-avg competency-scores-heading'>Average</Text> */}
                                        </View>
                                        <View style={[styles.competencyScoresContent]}>
                                            <View style={styles.competencyScoresBlank}></View>
                                            <View style={[styles.competencyScoresChart, styles.competencyScoresChartTextRight]}>
                                                <Image style={[{ objectFit: 'contain' }]} src={`data:image/png;base64,'${overview.chartImage}'`} />
                                            </View>
                                            <View style={[styles.competencyScoresAvg, { width: "12%" }]}>
                                                {
                                                    overview.series[0].data.map((value) => {
                                                        return (
                                                            <Text style={[styles['competencyoverviewAvgScore' + (Object.keys(report.raters).length + 1)], styles.grayColor, styles.textCenter, { marginLeft: '-20px'}]}>{value}</Text>

                                                        )
                                                    })
                                                }

                                            </View>
                                        </View>
                                        
                                        {
                                            (index + 1) % ((Object.keys(report.raters).length + 1) > 5 ? 4 : 5) === 0 && report.competencyOverview.length !== index + 1 ? 
                                            <>
                                            {renderRatingScale()}
                                            </>
                                            :  <></>
                                        }                                        
                                    </View>
                                    </>
                                )
                            })
                        }
                        {renderRatingScale()}
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (`${pageNumber}`)}  />
                    </View>
                </Page> : ''
            }
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Competency Breakout") ? 
                    report?.competencyBreakdown && report?.competencyBreakdown.map((competency, index) => {
                        const raterCount = Object.keys(report.raters).length + 1;

                        const FIRST_PAGE_LIMIT = raterCount > 5 ? 5 : 6;
                        const NEXT_PAGE_LIMIT = raterCount > 5 ? 6 : 7;

                        let itemCount = 0;
                        let currentLimit = FIRST_PAGE_LIMIT;
                        const hasFreeText = competency.openEnded?.some(open =>
                          open.answers && open.answers.length > 0
                        );
                        const hasOpinionScale =
                            competency.opinionScale &&
                            competency.opinionScale.length > 0;

                        // if (!hasOpinionScale) {
                        //     return null;
                        // }

                        return (
                            <Page key={"breakdown_" + index} style={[styles.page, styles.introduction]}>
                                {
                                    hasOpinionScale && (
                                        <>
                                            <Text render={onPageRender ? onPageRender("Competency Breakout") : undefined} fixed />                                
                                            <Text style={styles.introductionHeading}>Competency Breakout</Text>
                                            <Text style={styles.introductionHeadingBorder}></Text>
                                            <Text style={styles.paraText}>The Competency Breakout section of the report provides both the quantitative Findings on this Competency, as well as the Insights provided through open feedback.  Findings shows measures of the Competency, with an Average Rating and High & Low Ratings for each Rater Group. This information helps you to understand which behaviors or practices demonstrating this competency are observed (or not) and by which rater groups.</Text>
                                            <View style={[styles.competencyCommentsQuestion]}>
                                                <View style={styles.legendContainer}>
                                                    <View style={[styles.mr5px]}>
                                                        <Text style={[styles.overalltext, styles.fs10, styles.grayColor]}>A - Average</Text>
                                                    </View>
                                                    <View style={[styles.mr5px]}>
                                                        <Text style={[styles.overalltext, styles.fs10, styles.grayColor]}>H - Highest Score</Text>
                                                    </View>
                                                    <View style={[styles.mr5px]}>
                                                        <Text style={[styles.overalltext, styles.fs10, styles.grayColor]}>L - Lowest Score</Text>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={[styles.opinionScaleView, { marginBottom: "0", }]}>
                                                <Text style={[styles.rjPageSubHeading, styles.blueColor, { width: "94%" }]}>{competency.name}</Text>

                                                <View style={[{ width: "5%", marginLeft: '5px' }]}>
                                                    <Text style={[styles.blueColor, styles.fs10, { width: "2%", fontWeight: 800, marginLeft: '15px' }]}>A</Text>
                                                </View>
                                                <View style={{width: "5%"}}>
                                                    <Text style={[styles.blueColor, styles.fs10, { width: "2%", fontWeight: 800, marginLeft: '10px' }]}>H</Text>
                                                </View>
                                                <View style={{width: "5%"}}>
                                                    <Text style={[styles.blueColor, styles.fs10, { width: "2%", fontWeight: 800, marginLeft: '5px' }]}>L</Text>
                                                </View>
                                            </View>

                                            {
                                                competency?.opinionScale.map((opinionScale, scaleIndex) => {
                                                    let shouldBreak = false;

                                                    if (itemCount === currentLimit) {
                                                        shouldBreak = true;

                                                        // reset for next page
                                                        itemCount = 0;
                                                        currentLimit = NEXT_PAGE_LIMIT;
                                                    }

                                                    itemCount++;
                                                    return (
                                                        <View 
                                                            key={"breakdown_" + scaleIndex}
                                                            // style={[styles.opinionScaleView, styles.mb2]}
                                                            // wrap={false}
                                                        >
                                                            {shouldBreak && (
                                                                <View break={shouldBreak}>
                                                                    <Text style={styles.introductionHeading}>
                                                                        Competency Breakout, Cont'd
                                                                    </Text>
                                                                    <Text style={styles.introductionHeadingBorder}></Text>

                                                                    <Text style={[styles.rjPageSubHeading, styles.blueColor]}>
                                                                        {competency.name}
                                                                    </Text>
                                                                </View>
                                                            )}
                                                            <View style={[styles.opinionScaleView, styles.mb2]}>
                                                                {/* <Text style={[styles.questionText, { width: "55%" }]}>{opinionScale.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text> */}
                                                                <Text style={[styles.questionText, { width: "55%" }]}>{opinionScale.question}</Text>

                                                                {/* <Image src={`data:image/png;base64,'${opinionScale.chartImage}'`} style={{ width: '48%', height: '90px', objectFit: 'contain' }} /> */}
                                                                <Image src={`data:image/png;base64,'${opinionScale.chartImage}'`} style={{width: "70%", objectFit: 'contain' }} />
                                                                <View style={[ { width: "5%", marginLeft: '5px' }]}>
                                                                    {
                                                                        opinionScale.series[0].data.map((series) => {
                                                                            return (
                                                                                <Text style={[styles['competencyBreakdownAvgScore' + (Object.keys(report.raters).length + 1)], styles.grayColor]}>{(series)?series:0}</Text>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>
                                                                <View style={{width: "5%"}}>
                                                                    {
                                                                        opinionScale.series_high_low_data.map((series_high_low) => {
                                                                            return (
                                                                                <Text style={[styles['competencyBreakdownAvgScore' + (Object.keys(report.raters).length + 1)], styles.grayColor]}>{(series_high_low)?series_high_low.high:0}</Text>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>
                                                                <View style={{width: "5%"}}>
                                                                    {
                                                                        opinionScale.series_high_low_data.map((series_high_low) => {
                                                                            return (
                                                                                <Text style={[styles['competencyBreakdownAvgScore' + (Object.keys(report.raters).length + 1)], styles.grayColor]}>{(series_high_low)?series_high_low.low:0}</Text>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>
                                                            </View>
                                                        </View>
                                                    )
                                                })
                                            }
                                            {renderRatingScale()}
                                        </>
                                    )
                                }
                                
                                <View style={[styles.pageCount]} fixed>
                                    <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                                        `${pageNumber}`
                                    )} />
                                </View>
                                { hasFreeText && (
                                    <View break={hasOpinionScale === true ? true : false} key={"breakdown_comment_" + index} style={[styles.competencyComments2, { paddingTop: 0, marginTop: 0 }]}>
                                        {/* <Text style={styles.introductionHeading}>Competency Breakout - Insights</Text>
                                        <Text style={styles.introductionHeadingBorder}></Text>
                                        <Text style={styles.paraText}>The Competency Breakout - Insights is a summary of open feedback on your performance of this Competency. This information enables you to understand directly from your Raters who work with you day to day how they observe and experience your performance of this competency.</Text>
                                        <Text style={[styles.rjPageSubHeading, styles.blueColor, { marginBottom: '5px' }]}>{competency.name} Feedback</Text> */}
                                        {
                                            competency.openEnded.map((openEnded, openEndedIndex) => {
                                                // const MAX_CHAR = 2000;
                                                // let currentLines = 0;
                                                // const MAX_LINES = 34;
                                                // const TOLERANCE = 3;

                                                const FIRST_PAGE_HEADER = 1.5;   // Description ke saath
                                                const CONT_PAGE_HEADER  = 0.7;    // Description ke bina

                                                const PAGE_HEIGHT = 40;

                                                const FIRST_PAGE_HEIGHT = 40;
                                                const CONT_PAGE_HEIGHT = 46;

                                                let currentHeight = FIRST_PAGE_HEADER;
                                                let currentPageHeight = FIRST_PAGE_HEIGHT;
                                                // let isFirstPage = true;

                                                let currentPage = [];
                                                const pages = [];

                                                

                                                //group the comments
                                                const groupedComments = {};
                                                openEnded.answers.forEach((answer) => {
                                                    const groupName =
                                                        answer.subject_rater?.raterGroup?.name || "Other";

                                                    const groupKey = groupName
                                                        .split(" ")
                                                        .map((word) => word.charAt(0))
                                                        .join("");

                                                    if (!groupedComments[groupKey]) {
                                                        groupedComments[groupKey] = [];
                                                    }

                                                    groupedComments[groupKey].push(answer);
                                                });

                                                // console.log("groupedComments", groupedComments)

                                                // Randomize responses within each rater group
                                                Object.keys(groupedComments).forEach((groupKey) => {
                                                    groupedComments[groupKey] = shuffleArray(
                                                        groupedComments[groupKey]
                                                    );
                                                });

                                                Object.keys(groupedComments).forEach((groupKey) => {
                                                    groupedComments[groupKey].forEach((answer) => {

                                                        const commentHeight = Math.max(
                                                            2,
                                                            Math.ceil((answer.answer.length + groupKey.length + 10) / 90)
                                                        );

                                                        if (currentHeight + commentHeight > currentPageHeight) {
                                                            pages.push(currentPage);

                                                            currentPage = [];

                                                            currentHeight = CONT_PAGE_HEADER;
                                                            currentPageHeight = CONT_PAGE_HEIGHT;
                                                        }

                                                        currentPage.push({
                                                            answer,
                                                            groupKey
                                                        });

                                                        currentHeight += commentHeight;
                                                    });
                                                });

                                                if (currentPage.length) {
                                                    pages.push(currentPage);
                                                }

                                                // console.log("pages", pages)

                                                return (
                                                        <>
                                                            {/* Question */}
                                                            {/* <Text style={[styles.competencyCommentsQuestion, { fontWeight: 'bold' }]}>
                                                                {openEnded.question
                                                                    .replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName?.trim())
                                                                    .replace(/ORGANIZATION/g, report.organizationName?.trim())
                                                                    .replace(/PRONOUN/g, report.subjectPreferredPronoun?.trim())}
                                                            </Text> */}

                                                            {
                                                                pages.map((pageComments, pageIndex) => (
                                                                    <View
                                                                        key={pageIndex}
                                                                        break={pageIndex > 0 || openEndedIndex > 0}
                                                                    >
                                                                        <Text style={styles.introductionHeading}>
                                                                            {pageIndex === 0
                                                                                ? "Competency Breakout - Insights"
                                                                                : "Competency Breakout - Insights, Cont'd"}
                                                                        </Text>

                                                                        <Text style={styles.introductionHeadingBorder} />

                                                                        {
                                                                            pageIndex === 0
                                                                                ? <Text style={styles.paraText}>The Competency Breakout - Insights is a summary of open feedback on your performance of this Competency. This information enables you to understand directly from your Raters who work with you day to day how they observe and experience your performance of this competency.</Text>
                                                                                : null
                                                                        }

                                                                        <Text
                                                                            style={[
                                                                                styles.rjPageSubHeading,
                                                                                styles.blueColor,
                                                                                { marginBottom: 5 }
                                                                            ]}
                                                                        >
                                                                            {competency.name} Feedback
                                                                        </Text>

                                                                        <Text
                                                                            style={[
                                                                                styles.competencyCommentsQuestion,
                                                                                { fontWeight: "bold" }
                                                                            ]}
                                                                        >
                                                                            {openEnded.question
                                                                                .replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName?.trim())
                                                                                .replace(/ORGANIZATION/g, report.organizationName?.trim())
                                                                                .replace(/PRONOUN/g, report.subjectPreferredPronoun?.trim())}
                                                                        </Text>

                                                                        {
                                                                            pageComments.map(({answer, groupKey}, idx) => (
                                                                                <View key={idx} style={styles.openEndedComment}>
                                                                                    <Text style={[styles.competencyCommentsAnswer,{paddingRight:8}]}>
                                                                                        •
                                                                                    </Text>

                                                                                    <Text
                                                                                        style={[
                                                                                            styles.competencyCommentsAnswer,
                                                                                            styles.w98
                                                                                        ]}
                                                                                    >
                                                                                        {answer.answer}
                                                                                        {" "}
                                                                                        <Text style={[styles.spantext,  { textAlign: "left" }]}>
                                                                                            ({groupKey})
                                                                                        </Text>
                                                                                    </Text>
                                                                                </View>
                                                                            ))
                                                                        }
                                                                    </View>
                                                                ))
                                                            }

                                                            {
                                                                /* ✅ CHANGE: loop grouped data instead of openEnded.answers */
                                                                // Object.keys(groupedComments).map((groupKey, groupIndex) => (
                                                                //     <View key={"group_" + groupIndex}>

                                                                //         {/* ✅ Group Heading */}
                                                                //         {/* <Text style={[styles.competencyCommentsQuestion, { fontWeight: 'bold' }]}>
                                                                //             {groupKey}
                                                                //         </Text> */}

                                                                //         {
                                                                            
                                                                //             groupedComments[groupKey].map((answer, oeaIndex) => {

                                                                //                 const estimatedLines = Math.ceil(answer.answer.length / 100) || 1;

                                                                //                 let shouldBreak = false;

                                                                //                 if (estimatedLines > MAX_LINES) {
                                                                //                     shouldBreak = true;
                                                                //                     currentLines = estimatedLines;
                                                                //                 } 
                                                                //                 else if (
                                                                //                     currentLines !== 0 &&
                                                                //                     (currentLines + estimatedLines > MAX_LINES)
                                                                //                 ) {
                                                                //                     shouldBreak = true;
                                                                //                     currentLines = estimatedLines;
                                                                //                 } 
                                                                //                 else {
                                                                //                     currentLines += estimatedLines;
                                                                //                 }
                                                                //                 console.log("MAX_LINES---------", MAX_LINES)
                                                                //                 console.log("currentLines---------", currentLines)
                                                                //                 console.log("estimatedLines---------", estimatedLines)
                                                                //                 console.log("shouldBreak---------", shouldBreak)
                                                                //                 console.log(
                                                                //                     "Rendering Comment:",
                                                                //                     competency.name,
                                                                //                     openEnded.question,
                                                                //                     oeaIndex,
                                                                //                     answer.answer.substring(0, 50)
                                                                //                 );

                                                                                

                                                                //                 return (
                                                                //                     <View
                                                                //                         break={shouldBreak}
                                                                //                         key={"breakdown_feedback_" + groupIndex + "_" + oeaIndex}
                                                                //                         wrap
                                                                //                     >
                                                                //                         {shouldBreak && (
                                                                //                             <>
                                                                //                                 <Text style={styles.introductionHeading}>
                                                                //                                     Competency Breakout - Insights, Cont'd
                                                                //                                 </Text>
                                                                //                                 <Text style={styles.introductionHeadingBorder}></Text>

                                                                //                                 <Text style={[styles.rjPageSubHeading, styles.blueColor, { marginBottom: '5px' }]}>
                                                                //                                     {competency.name} Feedback
                                                                //                                 </Text>

                                                                //                                 <Text style={[styles.competencyCommentsQuestion, { fontWeight: 'bold' }]}>
                                                                //                                     {openEnded.question
                                                                //                                         .replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName?.trim())
                                                                //                                         .replace(/ORGANIZATION/g, report.organizationName?.trim())
                                                                //                                         .replace(/PRONOUN/g, report.subjectPreferredPronoun?.trim())}
                                                                //                                 </Text>
                                                                //                             </>
                                                                //                         )}

                                                                //                         {/* Comment */}
                                                                //                         <View style={styles.openEndedComment}>
                                                                //                             <Text style={[styles.competencyCommentsAnswer, { paddingRight: "8px" }]}>
                                                                //                                 &#x2022;
                                                                //                             </Text>
                                                                //                             <Text style={[styles.competencyCommentsAnswer, styles.w98]}>
                                                                //                                 {answer.answer} - <Text style={[styles.spantext,  { textAlign: "left" }]}>({groupKey})</Text>
                                                                //                             </Text>
                                                                //                         </View>

                                                                //                     </View>
                                                                //                 )
                                                                //             })
                                                                //         }

                                                                //     </View>
                                                                // ))
                                                            }
                                                        </>
                                                    )
                                            })
                                        }
                                    </View>
                                )}
                            </Page>
                        )
                    }) : ''
            }
            
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Confirmed Strengths/Opportunities") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Confirmed Strengths/Opportunities") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Confirmed Strengths</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Here are your Confirmed Strengths. These strengths are areas where your performance is stronger and aligned between your own observations and those of your Raters. Use these insights to continue building on what you already do well.</Text>
                        <View style={styles.ratersTable}>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Rank</Text>
                            <Text style={[styles.ratingthead, { width: "20%" }]}>Competency</Text>
                            <Text style={[styles.ratingthead, { width: "50%" }]}>Item</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Self</Text>
                            <Text style={[styles.ratingthead, { width: "15%", textAlign: 'center' }]}>Rater{"\n"} Average</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Gap</Text>
                        </View>
                        {
                            report?.confirmedStrengths && report.confirmedStrengths.map((confirmedStrength, csIndex) => {
                                return (
                                    <View style={[styles.ratersTable, styles.alignItems]}>
                                        <Text style={[styles.ratingtbody, { width: "5%" }]}>{csIndex + 1}</Text>
                                        <Text style={[styles.ratingtbody, { width: "20%" }]}>{confirmedStrength?.competency}</Text>
                                        <Text style={[styles.ratingtbody, { width: "50%" }]}>{confirmedStrength?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>

                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedStrength?.self_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "15%", display: 'flex', alignItems: 'center', justifyContent: 'center' }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedStrength?.rater_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedStrength?.gap}</Text>
                                        </View>
                                    </View>
                                )
                            })
                        }

                        <Text style={[styles.introductionHeading, styles.pt3]}>Confirmed Opportunities</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>These are your Confirmed Opportunities for growth. These areas have been consistently highlighted as key opportunities for improvement, both by yourself and others. Focusing on these items will help you enhance your effectiveness and continue your professional development.</Text>
                        <View style={styles.ratersTable}>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Rank</Text>
                            <Text style={[styles.ratingthead, { width: "20%" }]}>Competency</Text>
                            <Text style={[styles.ratingthead, { width: "55%" }]}>Item</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Self</Text>
                            <Text style={[styles.ratingthead, { width: "15%", textAlign: 'center' }]}>Rater{"\n"} Average</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Gap</Text>
                        </View>
                        {
                            report?.confirmedOpportunities && report.confirmedOpportunities.map((confirmedOpportunity, coIndex) => {
                                return (
                                    <View style={[styles.ratersTable, styles.alignItems]}>
                                        <Text style={[styles.ratingtbody, { width: "5%" }]}>{coIndex + 1}</Text>
                                        <Text style={[styles.ratingtbody, { width: "20%" }]}>{confirmedOpportunity?.competency}</Text>
                                        <Text style={[styles.ratingtbody, { width: "55%" }]}>{confirmedOpportunity?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>
                                        {/* <Text style={[styles.ratingtbody, styles.tableflex1]}>{confirmedOpportunity?.self_rating}</Text>
                                        <Text style={[styles.ratingtbody, styles.tableflex1]}>{confirmedOpportunity?.rater_rating}</Text>
                                        <Text style={[styles.ratingtbody, styles.ratingtbodygap, styles.tableflex1]}>{confirmedOpportunity?.gap}</Text> */}

                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedOpportunity?.self_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "15%", display: 'flex', alignItems: 'center', justifyContent: 'center' }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedOpportunity?.rater_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{confirmedOpportunity?.gap}</Text>
                                        </View>
                                    </View>
                                )
                            })
                        }
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }

            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Hidden Strengths/Opportunities") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Hidden Strengths/Opportunities") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Hidden Strengths</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Here are your Hidden Strengths, which represent areas where others recognize your performance is stronger, but you may not be fully aware of them yourself. Uncovering these hidden strengths can be incredibly valuable, as it allows you to leverage untapped potential and build confidence in areas you may have overlooked. By exploring and embracing these strengths, you can further enhance your impact and contribute even more effectively to your team and organization.</Text>
                        <View style={[styles.ratersTable]}>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Rank</Text>
                            <Text style={[styles.ratingthead, { width: "20%" }]}>Competency</Text>
                            <Text style={[styles.ratingthead, { width: "50%" }]}>Item</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Self</Text>
                            <Text style={[styles.ratingthead, { width: "15%", textAlign: 'center' }]}>Rater{"\n"} Average</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Gap</Text>
                        </View>
                        {
                            report?.hiddenStrengths && report.hiddenStrengths.map((hiddenStrength, hsIndex) => {
                                return (
                                    <View style={[styles.ratersTable, styles.alignItems]}>
                                        <Text style={[styles.ratingtbody, { width: "5%" }]}>{hsIndex + 1}</Text>
                                        <Text style={[styles.ratingtbody, { width: "20%" }]}>{hiddenStrength?.competency}</Text>
                                        <Text style={[styles.ratingtbody, { width: "55%" }]}>{hiddenStrength?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenStrength?.self_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "15%", display: 'flex', alignItems: 'center', justifyContent: 'center' }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenStrength?.rater_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenStrength?.gap}</Text>
                                        </View>
                                    </View>
                                )
                            })
                        }

                        <Text style={[styles.introductionHeading, styles.pt3]}>Blind Spots</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>These are your Blind Spots, which highlight areas for growth that others have observed but may not be on your radar yet. Recognizing and addressing these Blind Spots can be a powerful step in your development, as it opens up new avenues for improvement that you might not have considered. By becoming aware of these areas and actively working on them, you can enhance your overall performance and achieve greater success in your role and beyond.</Text>
                        <View style={styles.ratersTable}>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Rank</Text>
                            <Text style={[styles.ratingthead, { width: "20%" }]}>Competency</Text>
                            <Text style={[styles.ratingthead, { width: "50%" }]}>Item</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Self</Text>
                            <Text style={[styles.ratingthead, { width: "15%", textAlign: 'center' }]}>Rater{"\n"} Average</Text>
                            <Text style={[styles.ratingthead, { width: "5%" }]}>Gap</Text>
                        </View>
                        {
                            report?.hiddenOpportunities && report.hiddenOpportunities.map((hiddenOpportunity, hoIndex) => {
                                return (
                                    <View key={"ho_" + hoIndex} style={[styles.ratersTable, styles.alignItems]}>
                                        <Text style={[styles.ratingtbody, { width: "5%" }]}>{hoIndex + 1}</Text>
                                        <Text style={[styles.ratingtbody, { width: "20%" }]}>{hiddenOpportunity?.competency}</Text>
                                        <Text style={[styles.ratingtbody, { width: "50%" }]}>{hiddenOpportunity?.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>
                                        {/* <Text style={[styles.ratingtbody, styles.tableflex1]}>{hiddenOpportunity?.self_rating}</Text>
                                        <Text style={[styles.ratingtbody, styles.tableflex1]}>{hiddenOpportunity?.rater_rating}</Text>
                                        <Text style={[styles.ratingtbody, styles.ratingtbodygap, styles.tableflex1]}>{hiddenOpportunity?.gap}</Text> */}
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenOpportunity?.self_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "15%", display: 'flex', alignItems: 'center', justifyContent: 'center' }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenOpportunity?.rater_rating}</Text>
                                        </View>
                                        <View style={[styles.ratingtbody, { width: "5%" }]}>
                                            <Text style={[styles.strengthListScore]}>{hiddenOpportunity?.gap}</Text>
                                        </View>
                                    </View>
                                )
                            })
                        }
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }

            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Competency Index") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Competency Index") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Competency Index</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>The Competency Index Summary shows you the average rating from each rater group by item. Here you can compare your self-rating with the average ratings from your Rater groups. In addition, the largest difference from your self-rating is highlighted.</Text>


                        <View style={[styles.competencyCommentsQuestion]}>
                            <View style={styles.legendContainer}>
                                {report?.competencyBreakdown[0]?.opinionScale?.length > 0 &&
                                    report.competencyBreakdown[0].opinionScale[0]?.categories.map((category) => {
                                        return (
                                            <View style={[styles.mr5px]}>
                                                {/* <Text style={[styles.overalltext, styles.fs11, styles.grayColor]}>
                                                    <Text style={{ fontWeight: 'bold', color: '#000' }}>{category.substring(0, 1)}-{" "}</Text>
                                                    {category}
                                                </Text> */}
                                                <Text style={[styles.overalltext, styles.fs11, styles.grayColor]}>
                                                    <Text style={{ fontWeight: 'bold', color: '#000' }}>
                                                        {getCategoryInitials(category)} -{" "}
                                                    </Text>
                                                {category}
                                                </Text>
                                            </View>
                                        )
                                    })
                                }
                                <View style={[styles.mr5px]}>
                                    <Text style={[styles.overalltext, styles.fs11, styles.grayColor]}>
                                        <Text style={{ fontWeight: 'bold', color: '#000' }}>RA-</Text>
                                        Rater Average
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.lastTable}>
                            <View style={[styles.w25]}>
                                <View style={styles.legendTable}>
                                    <Text style={[styles.circleLegend, { backgroundColor: "#45a7c4" }]}></Text>
                                    <Text style={[styles.fs11, styles.grayColor]}>Confirmed Strengths</Text>
                                </View>
                            </View>
                            <View style={[styles.w25, { marginLeft: '5px' }]}>
                                <View style={styles.legendTable}>
                                    <Text style={[styles.circleLegend, { backgroundColor: "#8e8e8e" }]}></Text>
                                    <Text style={[styles.fs11, styles.grayColor]}>Confirmed Opportunities</Text>
                                </View>
                            </View>
                            <View style={[styles.w25, { marginLeft: '20px' }]}>
                                <View style={styles.legendTable}>
                                    <Text style={[styles.circleLegend, { backgroundColor: "#e68a4f" }]}></Text>
                                    <Text style={[styles.fs11, styles.grayColor]}>Hidden Strengths</Text>
                                </View>
                            </View>
                            <View style={[styles.w25]}>
                                <View style={styles.legendTable}>
                                    <Text style={[styles.circleLegend, { backgroundColor: "#8d6e63" }]}></Text>
                                    <Text style={[styles.fs11, styles.grayColor]}>Blind Spots</Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.overallTable, { alignItems: 'center' }]}>
                            <View style={[styles.overallbody, { width: "60%" }]}>

                            </View>

                            {report?.competencyBreakdown[0]?.opinionScale?.length > 0 &&
                                report.competencyBreakdown[0].opinionScale[0]?.categories.map((category) => {
                                    return (
                                        <View style={[styles.overallbody]}>
                                            {/* <Text style={[styles.ratingPoint, styles.fs10, { width: '4%' }]}>{category.substring(0, 1)}</Text> */}
                                            <Text style={[styles.ratingPoint, styles.fs10, { width: '4%' }]}>{getCategoryInitials(category)}</Text>
                                        </View>

                                    )
                                })
                            }
                            <View style={[styles.overallbody, { width: '4%' }]}>
                                <Text style={[styles.ratingPoint, styles.fs10]}>RA</Text>
                            </View>
                        </View>
                        {
                            report?.competencyBreakdown && report.competencyBreakdown.map((competency, cIndex) => {
                                return (
                                    competency?.opinionScale.map((opinionScale, osIndex) => {
                                        {compIndex++}
                                        return (
                                            // <View break={(cIndex + 1) % ((cIndex + 1) > 5 ? (cIndex + 1) > 9 ? 13 : 9 : 5) === 0 && osIndex === 0 ? true : false} style={(cIndex + 1) % ((cIndex + 1) > 5 ? (cIndex + 1) > 9 ? 13 : 9 : 5) === 0 && osIndex === 0 ? [styles.pt3] : []}>
                                            <View break={(compIndex % 16) === 0 ? true : false} style={(compIndex % 16) === 0 ? [styles.pt3] : []}>
                                                {/* {(cIndex + 1) % ((cIndex + 1) > 5 ? (cIndex + 1) > 9 ? 13 : 9 : 5) === 0 && osIndex === 0 ? <> */}
                                                    {(compIndex % 16) === 0 ? <>
                                                    {/* <Text style={styles.introductionHeading}>Competency Index</Text> */}
                                                    {/* <Text style={styles.introductionHeadingBorder}></Text> */}
                                                    <View style={[styles.competencyCommentsQuestion]}>
                                                        <View style={styles.legendContainer}>
                                                            {report?.competencyBreakdown[0]?.opinionScale?.length > 0 &&
                                                                report.competencyBreakdown[0].opinionScale[0]?.categories.map((category) => {
                                                                    return (
                                                                        <View style={[styles.mr5px]}>
                                                                            <Text style={[styles.overalltext, styles.fs11, styles.grayColor]}>
                                                                                <Text style={{ fontWeight: 'bold', color: '#000' }}>{getCategoryInitials(category)} -{" "}</Text>
                                                                            {category}</Text>
                                                                        </View>
                                                                    )
                                                                })
                                                            }
                                                            <View style={[styles.mr5px]}>
                                                                <Text style={[styles.overalltext, styles.fs11, styles.grayColor]}><Text style={{ fontWeight: 'bold', color: '#000' }}>RA-</Text>Rater Average</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={styles.lastTable}>
                                                        <View style={[styles.w25]}>
                                                            <View style={styles.legendTable}>
                                                                <Text style={[styles.circleLegend, { backgroundColor: "#45a7c4" }]}></Text>
                                                                <Text style={[styles.fs11, styles.grayColor]}>Confirmed Strengths</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.w25, { marginLeft: '5px' }]}>
                                                            <View style={styles.legendTable}>
                                                                <Text style={[styles.circleLegend, { backgroundColor: "#8e8e8e" }]}></Text>
                                                                <Text style={[styles.fs11, styles.grayColor]}>Confirmed Opportunities</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.w25, { marginLeft: '20px' }]}>
                                                            <View style={styles.legendTable}>
                                                                <Text style={[styles.circleLegend, { backgroundColor: "#e68a4f" }]}></Text>
                                                                <Text style={[styles.fs11, styles.grayColor]}>Hidden Strengths</Text>
                                                            </View>
                                                        </View>
                                                        <View style={[styles.w25]}>
                                                            <View style={styles.legendTable}>
                                                                <Text style={[styles.circleLegend, { backgroundColor: "#8d6e63" }]}></Text>
                                                                <Text style={[styles.fs11, styles.grayColor]}>Blind Spots</Text>
                                                            </View>
                                                        </View>
                                                    </View>
                                                    <View style={[styles.overallTable, { alignItems: 'center' }]}>
                                                        <View style={[styles.overallbody, { width: "60%" }]}>

                                                        </View>

                                                        {report?.competencyBreakdown[0]?.opinionScale?.length > 0 &&
                                                            report.competencyBreakdown[0].opinionScale[0]?.categories.map((category) => {
                                                                return (
                                                                    <View style={[styles.overallbody]}>
                                                                        <Text style={[styles.ratingPoint, styles.fs10, { width: '4%' }]}>{getCategoryInitials(category)}</Text>
                                                                    </View>

                                                                )
                                                            })
                                                        }
                                                        <View style={[styles.overallbody, { width: '4%' }]}>
                                                            <Text style={[styles.ratingPoint, styles.fs10]}>RA</Text>
                                                        </View>
                                                    </View>
                                                </> : <></>}
                                                <View style={[styles.overallTable]}>
                                                    <View style={[styles.overallbody, { width: "60%" }]}>
                                                        <View>
                                                            <Text style={[styles.fs10, { fontWeight: '500' }]}><Text style={[{ fontWeight: '600' }]}>{competency.name} - </Text>{opinionScale.question.replace(/SUBJECT_FIRST_NAME/g, report.subjectFirstName).replace(/ORGANIZATION/g, report.organizationName).replace(/PRONOUN/g, report.subjectPreferredPronoun)}</Text>
                                                        </View>
                                                    </View>
                                                    {report?.competencyBreakdown[0]?.opinionScale?.length > 0 &&
                                                        report.competencyBreakdown[0].opinionScale[0]?.categories.map((category, index) => {
                                                            return (
                                                                <View style={[styles.overallbody]}>
                                                                    <Text style={[styles.ratingPoint, styles.fs10, { width: '4%' }]}>{opinionScale.series[0].data[index]}</Text>
                                                                </View>
                                                            )
                                                        })
                                                    }
                                                    <View style={[styles.overallbody, { width: '4%' }]}>
                                                        {
                                                            report.confirmedStrengths && report.confirmedStrengths.find(item => item.question === opinionScale.question) ?
                                                                <Text style={{ fontSize: 10, border: "2px solid #45a7c4", borderRadius: "50%", color: "#45a7c4", padding: '3px', paddingTop: '5px', width: '20px', height: '20px', fontWeight: '600', textAlign: 'center' }}>{opinionScale.rater_average}</Text> :
                                                                report.confirmedOpportunities && report.confirmedOpportunities.find(item => item.question === opinionScale.question) ?
                                                                    <Text style={{ fontSize: 10, border: "2px solid #8e8e8e", borderRadius: "50%", color: "#8e8e8e", padding: '3px', paddingTop: '5px', width: '20px', height: '20px', fontWeight: '600', textAlign: 'center' }}>{opinionScale.rater_average}</Text> :
                                                                    report.hiddenStrengths && report.hiddenStrengths.find(item => item.question === opinionScale.question) ?
                                                                        <Text style={{ fontSize: 10, border: "2px solid #e68a4f", borderRadius: "50%", color: "#e68a4f", padding: '3px', paddingTop: '5px', width: '20px', height: '20px', fontWeight: '600', textAlign: 'center' }}>{opinionScale.rater_average}</Text> :
                                                                        report.hiddenOpportunities && report.hiddenOpportunities.find(item => item.question === opinionScale.question) ?
                                                                            <Text style={{ fontSize: 10, border: "2px solid #8d6e63", borderRadius: "50%", color: "#8d6e63", padding: '3px', paddingTop: '5px', width: '20px', height: '20px', fontWeight: '600', textAlign: 'center' }}>{opinionScale.rater_average}</Text> :
                                                                            <Text style={{ fontSize: 10, fontWeight: '600', paddingTop: '5px', textAlign: 'center' }}>{opinionScale?.rater_average}</Text>
                                                        }
                                                        {/* <Text style={[styles.ratingPoint]}>{opinionScale?.rater_average}</Text> */}
                                                    </View>
                                                </View>
                                            </View>
                                        )
                                    })
                                )
                            })
                        }

                    </View>         
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }

            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Processing Your 360-Degree Feedback") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Processing Your 360-Degree Feedback") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Processing Your 360-Degree Feedback</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={styles.paraText}>Receiving 360-degree feedback can be both enlightening and challenging. It’s natural to feel a range of emotions as you review the insights provided by your peers, direct reports, and managers. However, to make the most of this feedback, it's important to approach it with an open mind and a willingness to learn. Here are some best practices and suggestions to help you process your feedback effectively:</Text>
                        
                        <View style={[styles.pointBox]}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Acknowledge Your Initial Reactions: </Text>
                                It’s common to have an emotional response to feedback, especially if it’s unexpected or critical. Take a moment to recognize how you’re feeling without reacting impulsively. This emotional awareness will help you approach the feedback more objectively.
                            </Text>
                        </View>
                        <View style={[styles.pointBox]}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Balance Positive and Constructive Feedback: </Text>
                                People often tend to focus more on negative or constructive feedback, sometimes at the expense of overlooking positive feedback. Make sure to give equal weight to both. Your strengths are just as important as your areas for improvement and can serve as a foundation for further growth.
                            </Text>
                        </View>
                        <View style={[styles.pointBox]}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Avoid Dismissing Feedback You Disagree With: </Text>
                                It’s tempting to disregard feedback that doesn’t align with your self-perception. Instead of dismissing it, take time to reflect on it. Ask yourself why someone might see you in that light and whether there’s an opportunity to learn from their perspective.
                            </Text>
                        </View>
                        <View style={[styles.pointBox]}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Look for Patterns and Themes: </Text>
                                Pay attention to recurring themes in your feedback. If multiple raters are pointing out the same strengths or opportunities, this is a clear signal that these areas are significant to your overall performance. Patterns can also help you prioritize which areas to focus on first.
                            </Text>
                        </View>
                        <View style={[styles.pointBox]}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs12]}>&#8226;</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Seek Clarification When Needed: </Text>
                                If there are aspects of the feedback that are unclear or surprising, consider discussing them with your manager or a trusted colleague. Sometimes additional context can provide a deeper understanding and help you better interpret the feedback.
                            </Text>
                        </View>

                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }
            
            
            {
                report.reportContents !== null && report.reportContents.find(item => item.name === "Next Steps") ? 
                <Page wrap style={styles.page}>
                    <View style={styles.introduction}>
                        <Text render={onPageRender ? onPageRender("Next Steps") : undefined} fixed />
                        <Text style={styles.introductionHeading}>Next Steps</Text>
                        <Text style={styles.introductionHeadingBorder}></Text>
                        <Text style={[styles.paraText]}>Now that you’ve reviewed the report it’s important to harness your energy around the feedback and start identifying your priorities you wish to translate into action.  Here are some best practices and suggestions to help you organize your thoughts into effective and actionable steps:</Text>

                        <View style={styles.pointBox}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs10]}>1.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Take Time to Reflect: </Text>
                                After reading through the feedback, step away for a short period. This break allows you to process your initial emotional reactions and come back with a clearer mindset.
                            </Text>
                        </View>
                        <View style={styles.pointBox}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs10]}>2.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Review the Feedback Holistically: </Text>
                                Go through the entire report once again, focusing on both strengths and areas for development. Look at the feedback from different rater groups to understand the diverse perspectives.
                            </Text>
                        </View>
                        <View style={styles.pointBox}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs10]}>3.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Identify Key Takeaways: </Text>
                                Highlight the most important points, particularly those that are repeated across different sections or rater groups. These are likely the areas that need your attention the most.
                            </Text>
                        </View>
                        <View style={styles.pointBox}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs10]}>4.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Create an Action Plan: </Text>
                                Based on the feedback, develop a plan to capitalize on your strengths and address your opportunities for growth. Set specific, measurable goals with timelines to help you stay on track.
                            </Text>
                        </View>
                        <View style={styles.pointBox}>
                            <Text style={[styles.pointNumber, styles.textColor, styles.fs10]}>5.</Text>
                            <Text style={[styles.ratingtbody, styles.fs10]}>
                                <Text style={{fontWeight: 600}}>Follow Up: </Text>
                                Share your action plan with your manager or a mentor and seek their support in your development journey. Regularly check in on your progress and adjust your plan as needed based on ongoing feedback and self-reflection.
                            </Text>
                        </View>
                        <Text style={[styles.paraText, { marginTop: '15px' }]}>By following these steps and embracing a growth mindset, you can turn your 360-degree feedback into a powerful tool for exponential personal and professional growth. Remember, receiving feedback is an opportunity to elevate your performance and potential. How you choose to respond to it will significantly shape your future success. May you find inspiration in this simple yet powerful quote from William James – a renowned thought leader in psychology and philosophy - “Act as if what you do makes a difference. It does.”</Text>
                    </View>
                    <View style={styles.pageCount} fixed>
                        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => (
                            `${pageNumber}`
                        )} />
                    </View>
                </Page> : ''
            }                        
        </Document>
    )
}

export default ReportDownloadView;